import { Fragment, useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { CollectionAgent, CustomerApplication, CustomerWeb, Reward, RewardBill, RewardRates } from "../../../Constant";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import ApplicationForm from "./ApplicationTab";
import WebForm from "./WebTab";
import AmountRatio from "./AmountRatio";
import AgentTab from "./AgentTab";
import { useSelector } from "react-redux";

const RewardContainer = () => {
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [IconWithTab, setIconWithTab] = useState('1');
    const isReadOnly = authState.userRole !== 1;

    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}
            <Breadcrumbs mainTitle={RewardRates} parent="Settings" title={Reward} />
            <AmountRatio />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{RewardBill}</H3>
                </CardHeader>
                <CardBody>
                    <Nav className="nav-primary" tabs>
                        <NavItem>
                            <NavLink className={IconWithTab === '1' ? 'active' : ''} onClick={() => setIconWithTab('1')}><span className="fs-6 fw-bold cursor ">{CustomerApplication}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '2' ? 'active' : ''} onClick={() => setIconWithTab('2')}><span className="fs-6 fw-bold cursor">{CustomerWeb}</span></NavLink>
                        </NavItem>
                        {authState.userRole === 1 && (
                        <NavItem>
                            <NavLink className={IconWithTab === '3' ? 'active' : ''} onClick={() => setIconWithTab('3')}><span className="fs-6 fw-bold cursor">{CollectionAgent}</span></NavLink>
                        </NavItem>
                        )}
                    </Nav>

                    <TabContent activeTab={IconWithTab}>
                        <TabPane className="fade show" tabId="1">
                            <CardHeader className="pb-0">
                                <H3>{CustomerApplication}</H3>
                            </CardHeader>
                            <ApplicationForm />
                        </TabPane>
                        <TabPane tabId="2">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{CustomerWeb}</H3>
                            </CardHeader>
                            <WebForm />
                        </TabPane>
                        {authState.userRole === 1 && (
                        <TabPane tabId="3">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{CollectionAgent}</H3>
                            </CardHeader>
                            <AgentTab />
                        </TabPane>
                        )}
                    </TabContent>
                </CardBody>
            </Card>
        </Fragment>
    )
}
export default RewardContainer;